import React from 'react'

const TermsAndConditions = () => {
  return (
    <div className=" p-5">
      <h2>Términos y Condiciones de Uso de ConecTlajo</h2>
      <p>
        <strong>Fecha de última actualización:</strong> Marzo 2025
      </p>

      <p>
        <strong>Bienvenido a ConecTlajo</strong>, una aplicación desarrollada
        por{' '}
        <strong>
          <a
            target="_blank"
            rel="noopener noreferrer"
            style={{ color: 'blue' }}
            href="https://enigmatech.io"
          >
            Enigmatech
          </a>
        </strong>{' '}
        para <strong>Gobierno de tlajomulco</strong> que permite a los
        ciudadanos levantar reportes, denuncias e inspecciones, así como hacer
        el seguimiento de los mismos. Al utilizar nuestra aplicación, usted
        acepta cumplir con los términos y condiciones aquí establecidos. Si no
        está de acuerdo con estos términos, le solicitamos que no utilice
        nuestra aplicación.
      </p>

      <h3>1. Aceptación de los Términos</h3>
      <p>
        Al acceder o utilizar <strong>ConecTlajo</strong>, usted acepta estar
        sujeto a estos términos y condiciones, así como a nuestra política de
        privacidad. Si no está de acuerdo con alguna de las disposiciones, le
        pedimos que no utilice la aplicación.
      </p>

      <h3>2. Descripción del Servicio</h3>
      <p>
        <strong>ConecTlajo</strong> proporciona una plataforma para que los
        ciudadanos puedan:
        <ul>
          <li>
            Levantamiento de reportes de problemas o incidencias en su
            comunidad.
          </li>
          <li>
            Presentación de denuncias sobre situaciones que requieran atención
            de las autoridades locales.
          </li>
          <li>
            Realización de inspecciones relacionadas con diversos servicios o
            situaciones en su entorno.
          </li>
          <li>
            Seguimiento de los reportes, denuncias o inspecciones que hayan
            realizado.
          </li>
        </ul>
        El servicio está disponible exclusivamente para el municipio de{' '}
        <strong>Tlajomulco de Zúñiga</strong>, Jalisco. El acceso a los
        servicios fuera de este municipio no está habilitado.
      </p>

      <h3>3. Registro y Cuenta de Usuario</h3>
      <p>
        Para utilizar ciertas funcionalidades de la aplicación, como el
        levantamiento de reportes y denuncias, deberá crear una cuenta de
        usuario. Al registrarse, usted se compromete a proporcionar información
        precisa, completa y actualizada. Es su responsabilidad mantener la
        confidencialidad de su cuenta y notificar inmediatamente a{' '}
        <strong>Gobierno de tlajomulco</strong> si detecta cualquier uso no
        autorizado de su cuenta.
      </p>

      <h3>4. Uso de la Aplicación</h3>
      <p>
        <strong>Condiciones de Uso:</strong> Usted se compromete a usar la
        aplicación exclusivamente con fines legales y de acuerdo con estos
        términos. Cualquier uso inapropiado de la plataforma, incluyendo, pero
        no limitado a, el uso para fines fraudulentos o ilegales, está
        estrictamente prohibido.
      </p>
      <p>
        <strong>Contenido de los Reportes y Denuncias:</strong> Al presentar un
        reporte, denuncia o inspección, usted garantiza que la información que
        proporciona es verídica, precisa y no infringe ningún derecho de
        terceros. <strong>Gobierno de tlajomulco</strong> no se hace responsable
        de los contenidos generados por los usuarios.
      </p>
      <p>
        <strong>Prohibiciones:</strong> Usted no podrá, bajo ninguna
        circunstancia, usar la aplicación para transmitir virus, malware o
        cualquier otro tipo de software malicioso, ni para realizar actividades
        que puedan dañar, interrumpir o interferir con el funcionamiento de la
        aplicación.
      </p>

      <h3>5. Responsabilidad de Gobierno de tlajomulco</h3>
      <p>
        <strong>Gobierno de tlajomulco</strong> se compromete a ofrecer una
        plataforma funcional y segura para el uso de la aplicación{' '}
        <strong>ConecTlajo</strong>, pero no garantiza la disponibilidad
        continua del servicio. Nos reservamos el derecho de modificar o
        interrumpir la disponibilidad de la aplicación en cualquier momento y
        sin previo aviso.
      </p>

      <h3>6. Privacidad y Protección de Datos Personales</h3>
      <p>
        La recopilación y uso de los datos personales proporcionados por los
        usuarios se rige por nuestra <strong>Política de Privacidad</strong>. Al
        utilizar la aplicación, usted acepta el procesamiento de sus datos
        personales de acuerdo con dicha política.
      </p>

      <h3>7. Propiedad Intelectual</h3>
      <p>
        Todo el contenido, diseño, código y funcionalidad de la aplicación{' '}
        <strong>ConecTlajo</strong> son propiedad exclusiva de{' '}
        <strong>Gobierno de tlajomulco</strong> o de sus licenciantes. Queda
        prohibido modificar, distribuir, vender o reproducir cualquier parte de
        la aplicación sin la autorización expresa de{' '}
        <strong>Gobierno de tlajomulco</strong>.
      </p>

      <h3>8. Limitación de Responsabilidad</h3>
      <p>
        <strong>Gobierno de tlajomulco</strong> no se hace responsable de los
        daños directos, indirectos, incidentales, especiales, consecuenciales o
        punitivos que puedan surgir del uso o la imposibilidad de uso de la
        aplicación, incluyendo pero no limitándose a errores en el contenido,
        interrupciones en el servicio o la pérdida de datos.
      </p>

      <h3>9. Modificaciones de los Términos</h3>
      <p>
        <strong>Gobierno de tlajomulco</strong> se reserva el derecho de
        modificar estos Términos y Condiciones en cualquier momento. Cualquier
        cambio será publicado en esta sección con la fecha de la última
        actualización. Le recomendamos revisar periódicamente estos términos
        para estar al tanto de cualquier modificación.
      </p>

      <h3>10. Derecho a Suspender o Bannear Usuarios</h3>
      <p>
        Nos reservamos el derecho de suspender o bannear a cualquier usuario
        que, a nuestro juicio, esté informando casos falsos, inexactos o de
        broma. Esto incluye reportes, denuncias o inspecciones que no sean
        verídicos o que busquen interrumpir el servicio.
      </p>

      <h3>11. Ley Aplicable y Jurisdicción</h3>
      <p>
        Estos términos estarán regidos e interpretados de acuerdo con las leyes
        del <strong>Tlajomulco</strong>, sin perjuicio de cualquier disposición
        contraria en la legislación aplicable. Cualquier controversia
        relacionada con estos términos será resuelta en los tribunales
        competentes de <strong> Tlajomulco</strong>.
      </p>
    </div>
  )
}

export default TermsAndConditions
